<!--单位信息模块-->
<template>
  <div class="flexBetween">
    <div class="electricAnalyzeLi" v-for="item in electricAnalyze">
      <p :class="{'electricAnalyzeSafe':item.safe == 1,'electricAnalyzeDanger':item.safe == 0}">{{item.name}}</p>
      <p>{{item.value}}</p>
    </div>
  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import request from "@/api/http.js";
  export default {
    components: {},
    props: ['state'],
    data () {
      return {
        electricAnalyze1: [{
          name: "今年总耗水量",
          value: '6123',
        },
        {
          name: "今日水耗",
          value: '0',
          safe: 1,
        },
        {
          name: "昨日水耗",
          value: '34',
          safe: 1,
        },
        {
          name: "上月同期",
          value: '980',
          safe: 1,
        },
        {
          name: "本月水耗",
          value: '234',
          safe: 0,
        },
        {
          name: "上月水耗",
          value: '325',
          safe: 0,
        },
        {
          name: "去年同期",
          value: '23423',
          safe: 0,
        }],
        electricAnalyze2: [{
          name: "今年总耗电量",
          value: '23423',
        },
        {
          name: "今日电耗",
          value: '234',
          safe: 1,
        },
        {
          name: "昨日电耗",
          value: '634',
          safe: 1,
        },
        {
          name: "上月同期",
          value: '556',
          safe: 1,
        },
        {
          name: "本月电耗",
          value: '857',
          safe: 0,
        },
        {
          name: "上月电耗",
          value: '776',
          safe: 0,
        },
        {
          name: "去年同期",
          value: '678',
          safe: 0,
        }],
        electricAnalyze: []
      }
    },
    mounted () {
      this.getPowerValue(this.nowUnit.id)
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      }
    },
    watch: {
      nowUnit (nv,ov) {
        this.getPowerValue(nv.id)
      },
    },
    methods: {
      // 获取水量
      getPowerValue2 (unitId) {
        if(isempty(unitId)) {
          return
        }

        var now=new Date()
        var nowTime=now.getTime()
        var year=now.getFullYear()
        var month=now.getMonth()
        var day=now.getDate()
        var nowZero=new Date(year,month,day).getTime()

        var params={
          bgTime: new Date(year,0,1).getTime(),
          endTime: new Date(year+1,0,1).getTime(),
          unitId: unitId,
        }
        //获取今年用水量
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.success) {
            this.electricAnalyze[0].value=Number(res.data);
          }
        })


        //获取今日水量 
        var params={
          bgTime: nowZero,
          endTime: nowTime,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.success) {
            this.electricAnalyze[1].value=Number(res.data);
          }
        })

        //获取昨日电量
        var params={
          bgTime: nowZero-24*60*60*1000,
          endTime: nowZero-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.success) {
            this.electricAnalyze[2].value=Number(res.data);
          }
        })


        // 获取上个月同一天用电量，直接月份减1如果不存在就是空
        var lastMonthDate=new Date(year,month-1,day)
        var params={
          bgTime: lastMonthDate.getTime(),
          endTime: lastMonthDate.getTime()+24*60*60*1000-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.success) {
            this.electricAnalyze[3].value=Number(res.data);
          }
        })

        // 获取本月用电量 
        var params={
          bgTime: new Date(year,month,1).getTime(),
          endTime: nowTime,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.success) {
            this.electricAnalyze[4].value=Number(res.data);
          }
        })

        //获取上月用电量 
        var params={
          bgTime: new Date(year,month-1,1).getTime(),
          endTime: new Date(year,month-1,31).getTime()-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.success) {
            this.electricAnalyze[5].value=Number(res.data);
          }
        })

        // 获取去年同月用电量 
        var params={
          bgTime: new Date(year-1,month,1).getTime(),
          endTime: new Date(this.getLastDay(year-1,month+1)).getTime(),
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.success) {
            this.electricAnalyze[6].value=Number(res.data);
          }
        })
      },
      getPowerValue (unitId) {
        if(isempty(unitId)) {
          return
        }

        if(this.state==1) {
          this.getPowerValue2(unitId);
          this.electricAnalyze=this.electricAnalyze1;
          return
        } else {
          this.electricAnalyze=this.electricAnalyze2;
        }
        var now=new Date()
        var nowTime=now.getTime()
        var year=now.getFullYear()
        var month=now.getMonth()
        var day=now.getDate()
        var nowZero=new Date(year,month,day).getTime()
        //获取今年用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,0,1).getTime(),new Date(year+1,0,1).getTime(),respon => {
          this.electricAnalyze[0].value=Number(respon)
        })
        //获取今日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero,nowTime,respon => {
          this.electricAnalyze[1].value=Number(respon)
        })
        //获取昨日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero-24*60*60*1000,nowZero-1,respon => {
          this.electricAnalyze[2].value=Number(respon)
        })
        // 获取上个月同一天用电量，直接月份减1如果不存在就是空
        var lastMonthDate=new Date(year,month-1,day)
        this.$api.powerApi.getUnitUsePowerByDate(unitId,lastMonthDate.getTime(),lastMonthDate.getTime()+24*60*60*
          1000-1,respon => {
            this.electricAnalyze[3].value=Number(respon)
          })
        // 获取本月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month,1).getTime(),nowTime,respon => {
          this.electricAnalyze[4].value=Number(respon)
        })
        //获取上月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month-1,1).getTime(),new Date(year,month-1,31)
          .getTime()-
          1,respon => {
            this.electricAnalyze[5].value=Number(respon)
          })
        //获取上月用电量
        // this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month - 1, 1).getTime(), new Date(year, month, day)
        // 	.getTime() -
        // 	1, respon => {
        // 		this.electricAnalyze[5].value = Number(respon)
        // 	})
        // 获取去年同月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year-1,month,1).getTime(),new Date(this.getLastDay(
          year-1,month+1)).getTime(),respon => {
            this.electricAnalyze[6].value=Number(respon)
          })
      },
      getLastDay (year,month) {
        var new_year=year; //取当前的年份          
        var new_month=month++; //取下一个月的第一天，方便计算（最后一天不固定）          
        if(month>12) {
          new_month-=12; //月份减          
          new_year++; //年份增          
        }
        var new_date=new Date(new_year,new_month,1); //取当年当月中的第一天          
        return year+'-'+new_month+'-'+(new Date(new_date.getTime()-1000*60*60*24)).getDate(); //获取当月最后一天日期          
      }
    }
  }
</script>

<style scoped>
  .electricAnalyzeLi {
    flex-grow: 1;
    min-width: 120px;
    margin-right: 42px;
    border: solid 1px #E4E4E4;
    text-align: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
  }

  .electricAnalyzeLi>p:first-child {
    background: #409EFF;
    line-height: 36px;
    color: #FFFFFF;
  }

  .electricAnalyzeLi>p:last-child {
    font-size: .16rem;
    line-height: 42px;
  }

  .electricAnalyzeLi:last-child {
    margin-right: 0;
  }

  .electricAnalyzeSafe {
    background: #67C23A !important;
  }

  .electricAnalyzeDanger {
    background: #FF9900 !important;
  }
</style>